import { RiGalleryFill } from 'react-icons/ri'
import { AiFillCar } from 'react-icons/ai'
import { FaUserCircle } from 'react-icons/fa'
import { HiUserGroup } from 'react-icons/hi'
// import { GiSpring, GiStoneSphere } from 'react-icons/gi'
// import { BsXDiamond } from 'react-icons/bs'

export const menuData = [
  {
    label: 'User Management',
    id: 'user_management',
    items: [
      {
        label: 'Users',
        id: 'users',
        icon: <FaUserCircle />,
      },
      {
        label: 'Groups',
        id: 'groups',
        icon: <HiUserGroup />,
      },
    ],
  },
  {
    label: 'Data Management',
    id: 'data_management',
    items: [
      {
        label: 'Vehicle',
        id: 'vehicle',
        icon: <AiFillCar />,

        // createNew: true,
      },
      // {
      //   label: 'Quilt',
      //   id: 'quilts',
      //   icon: <BsXDiamond />,
      // },

      // {
      //   label: 'Material',
      //   id: 'materials',
      //   icon: <GiStoneSphere />,
      // },

      {
        label: 'Environment',
        id: 'environment',
        icon: <RiGalleryFill />,
      },
      {
        label: 'Vehicle Types',
        id: 'vehicleTypes',
        icon: <RiGalleryFill />,
      },
      {
        label: 'Hex Colors',
        id: 'hexColors',
        icon: <RiGalleryFill />,
      },

      {
        label: 'Materials',
        id: 'materials',
        icon: <RiGalleryFill />,
      },
      {
        label: 'Material Types',
        id: 'materialTypes',
        icon: <RiGalleryFill />,
      },
      {
        label: 'Defaults',
        id: 'defaults',
        icon: <RiGalleryFill />,
      },

      // {
      //   label: 'Stitching',
      //   id: 'sitching',
      //   icon: <GiSpring />,
      // },
    ],
  },
]
